export const BREADCRUMB_ITEM_ELEMENT = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.BreadcrumbWidgetElement';
